import { ControlType, InputType } from "../../../../../../../models";
import { forbiddenWords } from "../../../../../../../utils/ForbiddenWords";
import store from "../../../../../../../store";
import { selectUserInfo } from "../../../../../../../routes/Auth/auth.ducks";
import { selectAdData } from "../../../../../../../routes/AdForm/adForm.ducks";
import { popularDomainExtensions } from "../../../../../../../services/utils";

const validateRegex = (control, value, callback) => {
  if (control.regex) {
    if (!value.match(control.regex)) {
      callback(control.regexMessage || "Unesite valjanu vrijednost.");
    }
  }
};

const validateTextLength = (control, value, callback) => {
  if (control.max && value.length > control.max) {
    callback("Treba biti manji od {0} znakova.".replace("{0}", String(control.max)));
  }
};

const validateNumberMax = (control, value, callback) => {
  if (control.max && value > control.max) {
    callback("Unesite važeći broj.");
  }
};

const validateNumberMin = (control, value, callback) => {
  // Mileage can be 0 when the vehicle is marked as brand new. The ad form
  // stores this flag as `brandNew: true` (boolean) — when set, we skip
  // the default `control.min` (which is 1 for mileage) so users advertising
  // a new car can enter 0 km.
  if (control.field === "mileage") {
    const adData = selectAdData(store.getState());
    if (adData && adData.brandNew === true) {
      if (value === undefined || value === null || value === "") {
        callback("Unesite važeći broj.");
      }
      return;
    }
  }
  if ((control.min && value < control.min) || !value) {
    callback("Unesite važeći broj.");
  }
};

const validateExternalLinks = (control, value, callback) => {
  const state = store.getState();
  const user = selectUserInfo(state);

  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi;
  const valueWithoutEmails = value.replace(emailRegex, '');

  const urlRegex = /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9][-a-zA-Z0-9]*(?:\.[a-zA-Z0-9][-a-zA-Z0-9]*)+(?:\/[^\s]*)?/gi;
  const urls = valueWithoutEmails.match(urlRegex);

  if (urls) {
    const hasExternalLink = urls.some(url => {
      try {
        const urlWithProtocol = url.startsWith('http') ? url : `https://${url}`;
        const hostname = new URL(urlWithProtocol).hostname.toLowerCase();

        if (hostname.endsWith('index.hr')) return false;

        return popularDomainExtensions.some(ext => hostname.endsWith(ext));
      } catch (error) {
        return false;
      }
    });

    if (hasExternalLink) {
      const error = `Nije dozvoljeno unošenje poveznica do drugih web stranica.
      ${user.legalEntity ? " Ukoliko se radi o vašoj stranici, tu poveznicu možete unijeti u postavkama profila." : ""}`
      callback(error);
    }
  }
};


const validateForbiddenWords = (control, value, callback) => {
  let state = false;

  forbiddenWords.forEach(word => {
    // If you don't set the state, form would show multiple same errors in UI
    if (value.toLowerCase().includes(word.toLowerCase()) && !state) {
      callback("Unijeli ste nedozvoljene riječi. Promijenite tekst ili nas kontaktirajte na 091/6089171 ili na oglasi@index.hr.");
      state = true;
    }
  });
};

export const getTextItemError = (control, value) => {
  let error;
  const captureFirstError = message => {
    if (!error) {
      error = message;
    }
  };

  validateForbiddenWords(control, value, captureFirstError);
  validateTextLength(control, value, captureFirstError);
  validateRegex(control, value, captureFirstError);

  return error;
};

export default {
  validate(control, rule, value, callback) {
    if ((
      control.valueType === InputType.text ||
      control.valueType === InputType.string
    ) && value) {
      const inputValue = value[control.field];

      if (inputValue) {
        validateForbiddenWords(control, inputValue, callback);
      } else {
        callback("Molimo, unesite ovo polje!");
      }
    }

    if ((
      control.valueType === InputType.int ||
      control.valueType === InputType.float
    ) && value && control.type !== ControlType.money) {
      const inputValue = value[control.field];

      validateNumberMax(control, inputValue, callback);
      validateNumberMin(control, inputValue, callback);
    }

    if (control.type == ControlType.horsePower) {
      const inputValue = value[control.field];

      validateNumberMin(control, inputValue, callback);
      validateNumberMax(control, inputValue, callback);
    }

    if (control.type == ControlType.money) {
      const inputValue = value ? value[control.field] : undefined;
      const numValue = inputValue !== undefined && inputValue !== null && inputValue !== "" ? parseFloat(inputValue) : NaN;
      const isEmpty = inputValue === undefined || inputValue === null || inputValue === "";
      const isZero = numValue === 0;
      const hasValidValue = !isEmpty && !isNaN(numValue) && numValue > 0;

      if (control.isRequired && !hasValidValue) {
        callback("Unesite važeći broj.");
      } else if (hasValidValue) {
        validateNumberMax(control, numValue, callback);
        validateNumberMin(control, numValue, callback);
      } else if (isZero) {
        callback("Unesite važeći broj.");
      }
      // Empty optional field - no error, validation passes
    }

    if (value && value[control.field]) {
      const inputValue = value[control.field];
      validateTextLength(control, inputValue, callback);
      validateRegex(control, inputValue, callback);
      if (control.field === "description") {
        validateExternalLinks(control, inputValue, callback)
      }

    }

    callback();
  }
};



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/TextInputValidator.ts